import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitolavasacab() {



    const cardData = {

keyword: "Mumbai to Lavasa Cab",

headingDescription:
    "Mumbai Airport Cab offers safe, comfortable, and reliable Mumbai to Lavasa Cab services for families, couples, corporate travelers, weekend getaways, and nature lovers. We provide well-maintained Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus options with experienced chauffeurs for a smooth and scenic journey through the Western Ghats. With doorstep pickup across Mumbai, Mumbai Airport transfers, one-way and round-trip cab bookings, customized travel plans, 24/7 customer support, and transparent pricing, we ensure a hassle-free and enjoyable trip to Lavasa, India’s planned hill city known for its European-style architecture, lakeside promenade, lush green surroundings, and peaceful atmosphere.",

topPlaces: [
    {
        title: "Lavasa Lake Promenade",
        description:
            "Lavasa Lake Promenade is the heart of the city and one of its most attractive landmarks. The beautifully designed waterfront offers scenic walking paths, colorful buildings, cafes, and boating options. Visitors enjoy peaceful strolls along the lake while admiring the European-style architecture and calm waters, making it a perfect spot for relaxation and photography."
    },
    {
        title: "Dasve Viewpoint",
        description:
            "Dasve Viewpoint offers stunning panoramic views of Lavasa city, surrounded by green hills and the serene Warasgaon Lake. It is one of the best places to capture the beauty of Lavasa from above. The cool breeze, peaceful environment, and scenic landscapes make it a must-visit stop during a Mumbai to Lavasa cab journey."
    },
    {
        title: "Warasgaon Dam",
        description:
            "Warasgaon Dam is a major water reservoir near Lavasa and is known for its vast expanse of calm waters and surrounding greenery. The dam area is ideal for sightseeing, photography, and enjoying nature’s tranquility. During monsoon and winter seasons, the region becomes especially scenic with lush green hills and misty weather."
    },
    {
        title: "Temghar Dam",
        description:
            "Temghar Dam is another beautiful attraction near Lavasa, offering peaceful surroundings and scenic landscapes. The dam is less crowded, making it a perfect place for visitors seeking quiet relaxation and nature appreciation. The area is popular among photographers and travelers who enjoy offbeat destinations."
    },
    {
        title: "Lavasa Nature Trails",
        description:
            "Lavasa Nature Trails provide an opportunity to explore the region’s rich biodiversity and lush green forests. Visitors can enjoy walking paths, trekking routes, and guided nature experiences surrounded by hills and valleys. It is an ideal activity for adventure lovers and families looking to connect with nature."
    },
    {
        title: "Lakeside Water Sports Zone",
        description:
            "The Lakeside Water Sports Zone in Lavasa offers activities such as kayaking, jet skiing, pedal boating, and other recreational water adventures. It is a popular attraction for families, couples, and groups looking for fun and excitement while enjoying the scenic lake views."
    },
    {
        title: "Apollo Lavasa Hospital Area & Town Center",
        description:
            "Lavasa Town Center is a vibrant hub featuring colorful buildings, restaurants, shopping areas, and public spaces designed in a European town style. Visitors enjoy dining, shopping, and evening walks in this beautifully planned township, which gives Lavasa its unique identity."
    },
    {
        title: "Xthrill Adventure Academy",
        description:
            "Xthrill Adventure Academy offers thrilling outdoor activities such as ziplining, rappelling, wall climbing, and obstacle courses. It is designed for adventure enthusiasts and groups looking for adrenaline-filled experiences amidst the scenic backdrop of Lavasa’s hills."
    },
    {
        title: "Bamboosa Cultural Center",
        description:
            "Bamboosa Cultural Center showcases sustainable bamboo products and promotes eco-friendly craftsmanship. Visitors can explore handmade bamboo artifacts, learn about local artisanship, and purchase unique souvenirs. It reflects Lavasa’s commitment to eco-friendly development and culture."
    },
    {
        title: "Lonavala-Lavasa Scenic Route",
        description:
            "The journey from Mumbai to Lavasa via Lonavala and Tamhini Ghat is one of the most scenic road routes in Maharashtra. Travelers enjoy waterfalls, misty mountains, green valleys, and winding roads throughout the drive. The route itself becomes a memorable part of the Lavasa cab experience, especially during monsoon season."
    }
],



services: [
{
name: "Mumbai to Lavasa Cab",
description: "Mumbai Airport Cab offers Mumbai to Lavasa Cab service for safe, comfortable, and affordable travel to the scenic planned hill city of Lavasa near Pune. Whether you are planning a family vacation, weekend getaway, corporate outing, couple trip, sightseeing tour, or group travel, we provide well-maintained AC Sedan, Ertiga, Innova Crysta, Kia Carens, SUV, Tempo Traveller, and luxury vehicles. Our professional chauffeurs ensure a smooth journey via Mumbai–Pune Expressway with doorstep pickup, flexible travel schedules, one way and round trip options, transparent pricing, and 24x7 booking support. Enjoy a relaxing scenic drive to Lavasa with lake views, mountain roads, and premium travel comfort from Mumbai Airport Cab."
},
{
name: "Mumbai to Lavasa Taxi",
description: "Book Mumbai to Lavasa Taxi with Mumbai Airport Cab for convenient, safe, and hassle-free travel. Our clean AC vehicles, experienced drivers, affordable fares, and flexible pickup options make your journey comfortable for families, couples, and groups."
},
{
name: "Mumbai to Lavasa Taxi Fare",
description: "Get affordable Mumbai to Lavasa Taxi Fare with Mumbai Airport Cab. We provide transparent pricing, multiple vehicle options, and economical travel packages with no hidden charges for one way and round trip travel."
},
{
name: "Mumbai to Lavasa Cab Fare",
description: "Mumbai Airport Cab offers competitive Mumbai to Lavasa Cab Fare with professional chauffeurs, well-maintained vehicles, and reliable service for comfortable hill station travel."
},
{
name: "Cab from Mumbai to Lavasa",
description: "Choose a Cab from Mumbai to Lavasa with Mumbai Airport Cab and enjoy a safe and scenic journey with experienced drivers, AC vehicles, and smooth highway travel."
},
{
name: "Mumbai to Lavasa Car Rental",
description: "Book Mumbai to Lavasa Car Rental with chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, and luxury vehicles for flexible and comfortable travel tailored to your needs."
},
{
name: "Mumbai to Lavasa Cab Booking",
description: "Mumbai Airport Cab provides Mumbai to Lavasa Cab Booking with instant confirmation, 24x7 support, professional chauffeurs, and multiple vehicle options for all travel requirements."
},
{
name: "Mumbai to Lavasa One Way Cab",
description: "Travel conveniently with Mumbai to Lavasa One Way Cab service featuring fixed pricing, AC comfort, experienced drivers, and hassle-free pickup and drop services."
},
{
name: "Mumbai to Lavasa Round Trip Cab",
description: "Mumbai Airport Cab offers Mumbai to Lavasa Round Trip Cab packages for same-day returns, weekend trips, sightseeing tours, and family holidays with flexible schedules."
},
{
name: "Mumbai to Lavasa Outstation Cab",
description: "Book Mumbai to Lavasa Outstation Cab for reliable long-distance travel with premium vehicles, affordable fares, and customized travel plans for leisure and business trips."
},
{
name: "Mumbai to Lavasa Taxi Service",
description: "Mumbai Airport Cab provides Mumbai to Lavasa Taxi Service with safe transportation, clean AC vehicles, professional chauffeurs, and easy booking options."
},
{
name: "Mumbai to Lavasa Car Hire",
description: "Choose Mumbai to Lavasa Car Hire with Mumbai Airport Cab for chauffeur-driven travel with flexible timing, comfortable seating, and personalized service."
},
{
name: "Mumbai to Lavasa Hill Station Cab",
description: "Mumbai Airport Cab offers Mumbai to Lavasa Hill Station Cab service with scenic route travel, comfortable vehicles, and experienced drivers for a smooth hill journey."
},
{
name: "Mumbai to Lavasa Innova Cab",
description: "Book Mumbai to Lavasa Innova Cab for spacious and comfortable family travel with ample luggage space, AC comfort, and premium seating."
},
{
name: "Mumbai to Lavasa Ertiga Cab",
description: "Mumbai Airport Cab provides Mumbai to Lavasa Ertiga Cab service for economical family travel with comfortable seating, AC vehicles, and affordable pricing."
},
{
name: "Mumbai to Lavasa SUV Cab",
description: "Choose Mumbai to Lavasa SUV Cab for larger families and groups seeking spacious interiors, premium comfort, and smooth long-distance travel."
},
{
name: "Mumbai to Lavasa Weekend Cab",
description: "Book Mumbai to Lavasa Weekend Cab for relaxing short trips with flexible pickup timings, scenic drive experience, and comfortable chauffeur-driven travel."
},
{
name: "Mumbai to Lavasa Scenic Drive Cab",
description: "Mumbai Airport Cab offers Mumbai to Lavasa Scenic Drive Cab for enjoying the beautiful Mumbai–Pune Expressway route with mountains, tunnels, and lush green landscapes in complete comfort."
},
{
name: "Mumbai Airport to Lavasa Cab",
description: "Book Mumbai Airport to Lavasa Cab with direct pickup from domestic and international terminals. We provide flight tracking, luggage assistance, and comfortable AC vehicles."
},
{
name: "Navi Mumbai to Lavasa Cab",
description: "Mumbai Airport Cab offers Navi Mumbai to Lavasa Cab service with doorstep pickup, affordable fares, and comfortable travel options for families and groups."
}
],

tableData: [
["Mumbai to Lavasa Cab","Mumbai to Lavasa Taxi"],
["Mumbai to Lavasa Taxi Fare","Mumbai to Lavasa Cab Fare"],
["Cab from Mumbai to Lavasa","Mumbai to Lavasa Car Rental"],
["Mumbai to Lavasa Cab Booking","Mumbai to Lavasa One Way Cab"],
["Mumbai to Lavasa Round Trip Cab","Mumbai to Lavasa Outstation Cab"],
["Mumbai to Lavasa Taxi Service","Mumbai to Lavasa Car Hire"],
["Mumbai to Lavasa Hill Station Cab","Mumbai to Lavasa Innova Cab"],
["Mumbai to Lavasa Ertiga Cab","Mumbai to Lavasa SUV Cab"],
["Mumbai to Lavasa Weekend Cab","Mumbai to Lavasa Scenic Drive Cab"],
["Mumbai Airport to Lavasa Cab","Navi Mumbai to Lavasa Cab"]
],



whychoose: [
{
WhyChooseheading: "Reliable Mumbai to Lavasa Cab Service",
WhyChoosedescription: "Mumbai Airport Cab Service provides dependable Mumbai to Lavasa Cab transportation for families, couples, tourists, corporate travelers, and weekend vacationers seeking a comfortable journey."
},
{
WhyChooseheading: "Perfect Weekend Getaway Destination",
WhyChoosedescription: "Lavasa is a beautiful planned hill city surrounded by scenic landscapes, lakes, and mountains, making it a popular destination for leisure travelers."
},
{
WhyChooseheading: "Comfortable and Scenic Travel Experience",
WhyChoosedescription: "Enjoy a relaxing drive through picturesque routes and beautiful valleys while traveling from Mumbai to Lavasa in our well-maintained vehicles."
},
{
WhyChooseheading: "Multiple Vehicle Options Available",
WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles according to passenger count and travel preferences."
},
{
WhyChooseheading: "One-Way and Round Trip Facilities",
WhyChoosedescription: "Whether you need a one-way transfer, same-day return, round trip, or customized sightseeing itinerary, we provide flexible booking options."
},
{
WhyChooseheading: "Pickup Available Across Mumbai",
WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Andheri, Borivali, Dadar, Bandra, Powai, and nearby locations."
},
{
WhyChooseheading: "Safe and Professional Drivers",
WhyChoosedescription: "Our experienced drivers and regularly maintained vehicles ensure a safe, comfortable, and stress-free journey throughout the trip."
},
{
WhyChooseheading: "Ideal for Families, Couples, and Groups",
WhyChoosedescription: "From romantic vacations to family outings and corporate retreats, we provide suitable vehicle options for every type of traveler."
}
]
};

const faqData = [
{
question: "Why do travelers frequently book Mumbai to Lavasa Cabs?",
answer: "Lavasa is known for its scenic beauty, lakeside views, peaceful atmosphere, adventure activities, and relaxing weekend getaway experiences."
},
{
question: "Can I book a one-way cab from Mumbai to Lavasa?",
answer: "Yes, one-way cab services are available along with round-trip and customized sightseeing packages."
},
{
question: "Which vehicle is suitable for Mumbai to Lavasa travel?",
answer: "Sedan cars, Ertiga, and Innova Crysta are among the most preferred choices for comfortable hill destination travel."
},
{
question: "Are same-day return trips available?",
answer: "Yes, customers can choose same-day return travel depending on their sightseeing plans and schedule."
},
{
question: "Can families use this service for vacations?",
answer: "Yes, families frequently book Mumbai to Lavasa Cabs for holidays, picnics, and weekend trips."
},
{
question: "Do you provide Tempo Travellers for group travel?",
answer: "Yes, Tempo Travellers and larger vehicles are available for family groups, corporate outings, and sightseeing tours."
},
{
question: "Can customers start the journey from Mumbai Airport?",
answer: "Yes, pickup services are available from Mumbai Airport, railway stations, hotels, offices, and residential locations."
},
{
question: "Can sightseeing locations be included during the trip?",
answer: "Yes, customers can visit Lakeshore Promenade, Dasve View Point, Temghar Dam, Mulshi Lake, and other nearby attractions."
},
{
question: "Is advance reservation recommended for Mumbai to Lavasa travel?",
answer: "Yes, advance booking helps secure preferred vehicles and ensures smooth travel planning, especially during weekends and holidays."
},
{
question: "How can I book a Mumbai to Lavasa Cab?",
answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cab Service."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Akshay Jadhav",
feedback:
"We booked a Mumbai to Lavasa Cab for a weekend family trip. The vehicle was clean, comfortable, and the driver was very professional throughout the journey.",
rating: 5
},
{
id: 2,
name: "Mrs. Richa Shah",
feedback:
"Our Lavasa getaway was amazing with Mumbai Airport Cab Service. The pickup was on time, the cab was spacious, and the entire travel experience was smooth and enjoyable.",
rating: 5
}
];


































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];










const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Lavasa Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-lavasa-cab.jpg",
"description": "Book Mumbai to Lavasa cab service for a smooth and scenic hill station trip. Mumbai Airport Cabs offers reliable taxi service with professional drivers, clean vehicles, transparent pricing, and flexible one-way and round-trip options for Lavasa travel.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-lavasa-cab"
}
};







    return (
        <div>

<Helmet>
  <title>Mumbai to Lavasa Cab | Hill Station Taxi Service | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Lavasa cab service at affordable fares. Safe and comfortable taxi service with professional drivers, one-way and round-trip options, and reliable hill station travel from Mumbai to Lavasa."
/>

<meta
 name="keywords"
 content="mumbai to lavasa cab, mumbai to lavasa taxi, mumbai to lavasa taxi fare, mumbai to lavasa cab fare, cab from mumbai to lavasa, mumbai to lavasa car rental, mumbai to lavasa cab booking, mumbai to lavasa one way cab, mumbai to lavasa round trip cab, mumbai to lavasa outstation cab, mumbai to lavasa taxi service, mumbai to lavasa car hire, lavasa hill station cab mumbai, mumbai lavasa cab service"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>









            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/97.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitolavasacab;